import React, {useEffect} from 'react';
import {Flex, Text} from "@chakra-ui/layout";
import {Grid, Image, Link} from "@chakra-ui/react";
import Doc from "../../../images/teacher/doc.svg";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {getUploadedAssignments} from "../../../action/teacherAction";
import {useSelector} from "react-redux";

function UploadedAssignments() {
  const dispatch = useStudentAuthDispatch();
  const {data, assignments: {assignments}} = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const teacherToken = data.token.includes("Bearer") ? data.token.slice(17, (data.token.length - 2)) : data.token.slice(10, (data.token.length - 2));
  console.log(assignments)

  useEffect(() => {
    dispatch(getUploadedAssignments(teacherToken))
  }, []);

  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>Uploaded Assignments</Text>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(250px, 1fr))"} justifyContent={"center"}>
        {assignments.map((assignment, index) => (
            assignment.course_id === "" ? (
              <Text key={index} textTransform={"capitalize"} textAlign={"center"}>No Uploaded Assignments</Text>
            ) : (
              <Flex key={index} bgColor={"brand.white"} flexDirection={"column"} m={4} borderRadius={"20px"} p={6}>
                <Text textTransform={"capitalize"} fontWeight={"extrabold"}
                      fontSize={"lg"}>{assignment.course_name}</Text>
                <Link href={assignment.assignment_link} download my={3}>
                  <Image
                    title={"document"}
                    src={Doc}
                    alt={"document icon"}
                    boxSize={"30px"}
                    mr={1}
                    d={"inline-block"}
                  />
                  {assignment.course_name}{" "}{index + 1}
                </Link>
                <Text fontWeight={"semibold"} fontSize={"xs"}>Grade: {assignment.assignment_grade}</Text>
                <Text fontWeight={"semibold"} fontSize={"xs"}>Due Date: {assignment.assignment_due_date}</Text>
                <Flex justifyContent={"flex-end"}>
                  <i title={"Delete"} className="fa fa-trash fa-1x fa-red" aria-hidden="true">
                  </i>
                </Flex>
              </Flex>
            )
          )
        )}
      </Grid>
    </Flex>
  )
    ;
}

export default UploadedAssignments;